import { WizardState } from '../wizardModel';
import { CampaignFormValues } from '../wizardSubmission';
import { AdapterContext, baseValues, intervalValues, limitValue, toOutcome } from './common';
import { toCampaignRule, toSavedRule } from './ruleAdapter';

/**
 * Instant Reward: one rule, its prizes and the four issuance limits. The landing page and
 * prize pop-up copy are left to the module; `bc_visible` keeps the module's own default.
 */
export const instantRewardValues = (
  state: WizardState,
  context: AdapterContext
): CampaignFormValues => {
  const { limits } = state;
  return {
    ...baseValues(state, 'instant_outcome', context, true),
    rules: state.triggers
      .slice(0, 1)
      .map(trigger => toSavedRule(toCampaignRule(trigger, 'instant_outcome', context.t))),
    outcomes: state.prizes.map(toOutcome),
    campaign_lifetime_max_available: limitValue(limits.totalOn, limits.total),
    account_lifetime_max_available: limitValue(limits.perUserOn, limits.perUser),
    ...intervalValues(
      'campaign',
      'campaign_interval_max_available',
      limits.rateOn,
      limits.rate,
      limits.ratePeriod
    ),
    ...intervalValues(
      'account',
      'account_interval_max_available',
      limits.userRateOn,
      limits.userRate,
      limits.userRatePeriod
    ),
    auto_redeem_outcome: limits.autoRedeem,
    bc_visible: false
  };
};
